import { render, staticRenderFns } from "./accord.vue?vue&type=template&id=1ed71582&scoped=true"
import script from "./accord.vue?vue&type=script&lang=ts"
export * from "./accord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed71582",
  null
  
)

export default component.exports